/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toggleHighContrast } from 'actionCreators';
import PropTypes from 'prop-types';

const Button = ({ isToggled, size }) => {
  let width;
  let height;
  let x;
  let y;

  switch (size) {
    case 'small':
      width = 35;
      height = 18;
      x = 8;
      y = 18;
      break;
    case 'medium':
      width = 50;
      height = 25;
      x = 11;
      y = 25;
      break;
    case 'large':
      width = 100;
      height = 50;
      x = 22;
      y = 50;
      break;
    default:
      width = 35;
      height = 18;
      x = 8;
      y = 18;
  }

  const buttonPosition = isToggled
    ? `translate(-${x}px,-${y}px)`
    : `translate(${x}px,-${y}px)`;

  return (

    <div
      style={{
        height,
        width,
        display: 'grid',
        transform: buttonPosition,
        transition: 'transform 200ms ease-out',
      }}
    >
      <svg
        height="100%"
        width="100%"
        viewBox="0 0 16 16"
      >
        <circle
          id="Button"
          cx="8"
          cy="8"
          r="8"
          fill="#1a1a1a"
        />
      </svg>
    </div>

  );
};

const ToggleContrast = (props) => {
  /**
   * The local state is set using react hooks (useState). Initial state is
   * set from redux state.
   * Redux state uses localStorage to save configurations
   */
  const [isToggled, setToggle] = useState(props.useHighContrast);
  let width;
  let height;

  switch (props.size) {
    case 'small':
      width = 35;
      height = 18;
      break;
    case 'medium':
      width = 50;
      height = 25;
      break;
    case 'large':
      width = 100;
      height = 50;
      break;
    default:
      width = 35;
      height = 18;
  }

  function handleClick() {
    const toggledState = !isToggled;
    localStorage.setItem('useHighContrast', JSON.stringify(toggledState));
    setToggle(toggledState);
    props.toggleHighContrast();
  }

  return (

    <div style={{ marginTop: 10 }}>Contrast
        <div
          style={{
            marginTop: 5,
            paddingBottom: 10,
          }}
        >
          <span style={{ display: 'flex', flexWrap: 'wrap' }}>

            <div
              style={{
                overflow: 'hidden',
                height,
                width,
                cursor: 'pointer',
              }}
              onClick={handleClick}
            >
              <div style={{ height, width, display: 'grid' }}>
                <svg height="100%" width="100%" viewBox="0 0 35 18">
                  <path
                    id="Body"
                    d="M33.22 2a8.43 8.43 0 1 1 0 16.86H16.35a8.43 8.43 0 0 1 0-16.86z"
                    transform="translate(-7.42 -1.54)"
                    fill={isToggled ? '#EFB300' : '#3A91E8'}
                    stroke="#1a1a1a"
                    strokeMiterlimit="10"
                  />
                </svg>
              </div>
              <Button isToggled={isToggled} size={props.size} />
            </div>
            <span style={{ fontSize: 12, margin: 3 }}>
              {isToggled
                ? 'High'
                : 'Normal'}
            </span>

          </span>
        </div>
    </div>

  );
};

Button.propTypes = {
  isToggled: PropTypes.bool,
  size: PropTypes.string,
};

ToggleContrast.propTypes = {
  size: PropTypes.string,
  useHighContrast: PropTypes.bool,
  toggleHighContrast: PropTypes.func,
};

function mapStateToProps(state) {
  const useHighContrast = state.settings.useHighContrast;
  return { useHighContrast };
}

export default connect(mapStateToProps, { toggleHighContrast })(ToggleContrast);



// WEBPACK FOOTER //
// ./client/app/shared/components/NavigationBar/toggleContrast.jsx